import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Tooltip from 'rc-tooltip'
import 'rc-tooltip/assets/bootstrap_white.css';
import moment from 'moment';

import SegmentAttribute from './SegmentAttribute'
import Setting from 'material-ui/svg-icons/action/settings';
import { splitNumber } from '../../../utils/utility'
import { Row, Col } from '../../framework/Grid'
import { Dialog } from 'material-ui'
import NavList from '../List/NavList';

class SegmentSummary extends Component {
	componentWillMount() {
		this.state = {
			clientWidth: 0,
			clientHeight: 0,
			hasArchived: false,
			loaded: true
		}
	}
	componentDidMount() {
		if (!this.props.segment_summary) {
			this.props.fetchSegmentDetail(this.props.segment_id)
		}
		const width = document.getElementById('segment-summary-container').clientWidth
		const height = document.getElementById("segment-summary-container").clientHeight
		this.setState({
			clientWidth: width,
			clientHeight: height
		})
	}
	handleConfirmArchive(id) {
		this.setState({
			archivedId: id
		})
		this.props.archiveSegment(id);

		window.setTimeout(() => {
			this.setState({
				hasArchived: true
			}, () => {
				this.props.updateSegmentList(this.state.activeIndex) // update segment list when archive success
			})
		}, 2000)
	}

	handleCancelArchive(e) {
		this.setState({
			popout: false
		})
	}

	handleCreateRedirect(){
		const {segment_summary, handleActiveRedirectCreate} = this.props
		handleActiveRedirectCreate(segment_summary.id, segment_summary.clientId)
	}

	getContent() {
		const { segment_summary, segment_attributes, demoAttributes, geoAttributes } = this.props
		return [
			<div key="segment-summary-div" className="top-copy-archive clearfix" style={{ paddingLeft: '6.5%' }}>
				<span className="font-12em" style={{ fontWeight: 'bolder' }}>{segment_summary.name}{this.state.clientWidth}-{this.state.clientHeight}</span>
				<Tooltip
					ref={(node) => this._tooltip = node}
					hideAction={['click', 'hover']}
					placement="right"
					overlay={
						<NavList
							visible={!this.props.showLoadingDialog}
							handleActiveRedirectCreate={this.handleCreateRedirect.bind(this)}
							popout={this.props.popout}
							handleConfirmArchive={() => this.handleConfirmArchive(segment_summary.id)}
							popoutTip={() => this.props.popoutTip()}
							handleCancelArchive={() => this.props.handleCancelArchive()}
							ifShowPdfDownload={true}
							createCampaignPopover={() => this.props.createCampaignPopover(segment_summary.id, segment_summary.clientId)}
							_handleDownloadPDF={() => this.props._handleDownloadPDF(segment_summary, segment_attributes, demoAttributes, geoAttributes)}
						/>
					}
					defaultVisible={false}
					arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
				>
					<Setting style={{ float: 'left' }} />
				</Tooltip>
			</div>,
			<ul key="segment-summary-list" className="copy-archive-ul clearfix" style={{ width: "92%" }}>
				<li className="clearfix" style={{ marginLeft: "2em" }}>
					<span>Date</span>
					<strong>
						<em>{moment(segment_summary.createdTime, 'x').format('MMMM D, YYYY')}</em>
					</strong>
				</li>
				<li className="clearfix" style={{ marginRight: "1em" }}>
					<span>Attributes</span>
					<strong style={{ width: "78%" }}>
						<em>{segment_attributes}</em>
					</strong>
				</li>
				<li className="clearfix" style={{ marginLeft: "2em" }}>
					<span>Client</span>
					<strong><em>{segment_summary.clientName}</em></strong>
				</li>
			</ul>,
			<Row className="pt-10 no-padding-bottom no-padding-left "
				style={{
					marginLeft: '5%', marginRight: '5.5%', fontSize: '10pt', marginBottom: '30px',
					borderTop: "solid 1px #C3C3C3", borderBottom: 'solid 1px #C3C3C3'
				}} >
				<div key="summany-audience-count" style={{ float: 'left', width: '48%', paddingLeft: '5px' }}>
					<span className="ml-10 text-default text-bold">
						Audience: {splitNumber(segment_summary.count + '')()}
					</span>
				</div>
				<div key='label-channel' style={{ float: 'left', width: '14%', textAlign: 'right' }}>
					Reach by Channel
						</div>
				<div key="summary-email-count" style={{ float: 'left', width: '12%', textAlign: 'right' }}>
					<p><i className="icon-envelope" style={{ fontSize: '1.2em' }} /><span className="ml-10 text-default text-bold">{splitNumber(segment_summary.email + '')()}</span></p>
				</div>
				<div key="summary-social-count" style={{ float: 'left', width: '12%', textAlign: 'right' }}>
					<p><i className="icon-share3" style={{ fontSize: '1.2em' }} /><span className="ml-10 text-default text-bold">{splitNumber(segment_summary.social + '')()}</span></p>
				</div>
				<div key="summary-display-count" style={{ float: 'left', width: '12%', textAlign: 'right' }}>
					<p><i className="icon-display4" style={{ fontSize: '1.2em' }} /><span className="ml-10 text-default text-bold">{splitNumber(segment_summary.display + '')()}</span></p>
				</div>
			</Row>
		]
	}

	render() {
		const { segment_summary, demoAttributes, geoAttributes } = this.props
		const datas = this.props._generateSelectData(segment_summary)

		return (
			this.state.hasArchived === true ? <div>
				The segment has been archived. <a href="archive">View Archive</a>
			</div> :
				<div id="segment-summary-container">
					{segment_summary ? this.getContent() : "loading..."}
					<Dialog open={this.props.showLoadingDialog}
						style={{ top: '-1.8em' }}
						modal={true}>
						<Row className="mt-20">
							<Col xs="7" sm="7" md="7" lg="7" className="text-right">
								<div>Downloading, please wait...</div>
							</Col>
							<Col xs="1" sm="1" md="1" lg="1">
								<img alt="" src="/Spinner.gif" style={{ height: "24px" }} />
							</Col>
						</Row>
					</Dialog>
					<SegmentAttribute data={datas} rawData={segment_summary ? segment_summary.rawData : ""}
						demoAttributes={demoAttributes} geoAttributes={geoAttributes} width={this.state.clientWidth} />
				</div>
		)
	}
}

SegmentSummary.propTypes = {
	segment_summary: PropTypes.object,
	segment_id: PropTypes.number.isRequired,
	fetchSegmentDetail: PropTypes.func.isRequired
}

export default SegmentSummary


// WEBPACK FOOTER //
// ./src/components/Segment/Detail/SegmentSummary.jsx